// @flow
import { relationshipReducer } from "src/utils/reducerUtils";
import seriesTrendsSchema from "src/schemas/seriesTrendSchema";

export const seriesTrendRelationships = relationshipReducer({
  name: "seriesTrends",
  relationshipSchemas: seriesTrendsSchema.relationshipSchemas
});
